<template>
  <div class="package-config">
    <div class="section-body">
      <!-- 标题行与表单项共用窄标签列（四字标题够用即可，避免标签列过宽、左右留白不均） -->
      <div class="package-cover-block">
        <div
          class="package-cover-head pkg-field-row pkg-field-row--cover-title"
        >
          <span class="pkg-field-label"
            ><span class="req-star">*</span>套餐图片</span
          >
          <span class="detail-title-hint detail-title-hint--after-label">{{
            packageImageHintText
          }}</span>
        </div>
        <div class="package-cover-upload-wrap">
          <SUpload
            v-if="imagesEditable"
            v-model="packageData.coverUrl"
            actionUrl="/adminapi/v1/basicTools/v650/file/upload?uploadImageType=11&fileType=1"
            :headers="uploadAuthHeaders"
            accept="image/*"
            type="drag"
            :size="50"
            :show-file-list="false"
          />
          <div v-else-if="packageData && packageData.coverUrl" class="match-upload-preview-box match-upload-preview-box--view" @click="$emit('preview-image', packageData.coverUrl)">
            <img :src="packageData.coverUrl" alt="" />
          </div>
          <div v-else class="match-upload-empty-view">暂无图片</div>
        </div>
      </div>

      <el-form-item label="" label-width="0px" class="pkg-field-item">
        <div class="pkg-field-row">
          <span class="pkg-field-label"
            ><span class="req-star">*</span>套餐标题</span
          >
          <div class="pkg-field-body">
            <el-input
              v-model="packageData.packageTitle"
              placeholder="请输入套餐标题，不超过20个字"
              :maxlength="20"
              show-word-limit
              class="same-width-input"
              :disabled="readonly"
            ></el-input>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="" label-width="0px" class="pkg-field-item">
        <div class="pkg-field-row">
          <span class="pkg-field-label"
            ><span class="req-star">*</span>套餐价格</span
          >
          <div class="pkg-field-body">
            <div class="inline-form-row">
              <el-radio-group
                v-model="packageData.priceType"
                class="pace-radio-group"
                :disabled="readonly"
              >
                <el-radio :label="1">免费</el-radio>
                <el-radio :label="2">付费</el-radio>
              </el-radio-group>
              <template v-if="packageData.priceType === 2">
                <el-input
                  ref="priceInput"
                  v-model="packageData.price"
                  placeholder="请输入套餐价格，最多两位小数"
                  style="width: 120px; margin-left: 10px"
                  :disabled="readonly"
                  @keydown.native="onPriceKeydown"
                  @paste.native.prevent="onPricePaste"
                  @input="onPriceInput"
                  @blur="onPriceBlur"
                  @compositionend.native="onPriceCompositionEnd"
                ></el-input>
                <span class="price-unit">元</span>
              </template>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="" label-width="0px" class="pkg-field-item">
        <div class="pkg-field-row">
          <span class="pkg-field-label"
            ><span class="req-star">*</span>限量类型</span
          >
          <div class="pkg-field-body">
            <el-radio-group
              v-model="packageData.limitType"
              :disabled="readonly"
            >
              <el-radio :label="1">套餐限量</el-radio>
              <el-radio :label="2">奖品限量</el-radio>
            </el-radio-group>
          </div>
        </div>
      </el-form-item>

      <el-form-item
        v-if="!readonly"
        label=""
        label-width="0px"
        class="pkg-field-item"
      >
        <div class="pkg-field-row">
          <span class="pkg-field-label"
            ><span class="req-star">*</span>关联奖品</span
          >
          <div class="pkg-field-body">
            <el-button type="text" @click="onRelatePrize">去关联</el-button>
          </div>
        </div>
      </el-form-item>

      <el-form-item
        label=""
        label-width="0px"
        v-if="packageData.prizeList.length > 0"
        class="pkg-field-item"
      >
        <div class="pkg-field-row">
          <span class="pkg-field-spacer" aria-hidden="true"></span>
          <div class="pkg-field-body">
            <el-table :data="packageData.prizeList" border style="width: 100%">
              <el-table-column
                prop="prizeId"
                label="奖品ID"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="prizeName"
                label="奖品名称"
                width="120"
                align="center"
              ></el-table-column>
              <el-table-column label="奖品类型" width="100" align="center">
                <template slot-scope="scope">{{
                  getPrizeTypeLabel(scope.row.prizeType)
                }}</template>
              </el-table-column>
              <el-table-column
                v-if="packageData.limitType === 2"
                label="报名限量（指前X个报名的用户可获得奖励）"
                min-width="280"
                align="left"
              >
                <template slot-scope="scope">
                  <div class="cell-inline">
                    <el-radio-group
                      v-model="scope.row.signLimitType"
                      :disabled="readonly"
                    >
                      <el-radio :label="0">不限</el-radio>
                      <el-radio :label="1">限量</el-radio>
                    </el-radio-group>
                    <el-input
                      v-if="scope.row.signLimitType === 1"
                      v-model="scope.row.signLimit"
                      style="width: 120px; margin-left: 6px"
                      placeholder="请输入整数"
                      :disabled="readonly"
                      @keydown.native="onSignLimitKeydown"
                      @paste.native.prevent="
                        (e) => onSignLimitPaste(e, scope.row)
                      "
                      @input="(val) => onSignLimitInput(val, scope.row)"
                      @compositionend.native="
                        (e) => onSignLimitCompositionEnd(e, scope.row)
                      "
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="是否活动限定"
                min-width="300"
                align="left"
              >
                <template slot-scope="scope">
                  <div class="cell-inline">
                    <el-radio-group
                      v-model="scope.row.activityLimitType"
                      :disabled="readonly"
                    >
                      <el-radio :label="0">否</el-radio>
                      <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                    <el-input
                      v-if="scope.row.activityLimitType === 1"
                      v-model="scope.row.activityLimit"
                      style="width: 150px; margin-left: 6px"
                      placeholder="请输入标签名"
                      :maxlength="10"
                      show-word-limit
                      :disabled="readonly"
                    ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="是否隐藏(报名页及待支付页不显示)"
                min-width="300"
                align="left"
              >
                <template slot-scope="scope">
                  <div class="cell-inline">
                    <el-radio-group
                      v-model="scope.row.isHide"
                      :disabled="readonly"
                    >
                      <el-radio :label="0" :value="0">否</el-radio>
                      <el-radio :label="1" :value="1">是</el-radio>
                    </el-radio-group>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="!readonly"
                label="操作"
                width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    style="color: #f56c6c"
                    @click="removePrize(scope.$index)"
                    >取消关联</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-form-item>

      <el-form-item
        label=""
        label-width="0px"
        v-if="packageData.limitType === 1"
        class="pkg-field-item"
      >
        <div class="pkg-field-row">
          <span class="pkg-field-label"
            ><span class="req-star">*</span>套餐库存</span
          >
          <div class="pkg-field-body">
            <div class="inline-form-row">
              <el-radio-group
                v-model="packageData.stockType"
                class="pace-radio-group"
                :disabled="readonly"
              >
                <el-radio :label="0">不限量</el-radio>
                <el-radio :label="1">限量</el-radio>
              </el-radio-group>
              <el-input
                v-if="packageData.stockType === 1"
                ref="stockInput"
                v-model="packageData.stock"
                placeholder="请输入库存数量"
                style="width: 120px; margin-left: 10px"
                :disabled="readonly"
                @keydown.native="onStockKeydown"
                @paste.native.prevent="onStockPaste"
                @input="onStockInput"
                @compositionend.native="onStockCompositionEnd"
              ></el-input>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item
        label=""
        label-width="0px"
        v-if="hasPhysicalPrize"
        class="pkg-field-item"
      >
        <div class="pkg-field-row">
          <span class="pkg-field-label pkg-field-label--wide"
            ><span class="req-star">*</span>实物奖励发货时限</span
          >
          <div class="pkg-field-body">
            <el-select
              v-model="packageData.deliveryDeadline"
              placeholder="请选择发货时限"
              style="width: 240px"
              :disabled="readonly"
            >
              <el-option
                label="完赛后7个工作日内"
                value="完赛后7个工作日内"
              ></el-option>
              <el-option
                label="完赛后15个工作日内"
                value="完赛后15个工作日内"
              ></el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
    </div>
  </div>
</template>

<script>
const LOG_TAG = "[赛事详情]";

export default {
  name: "PackageConfig",
  props: {
    packageData: {
      type: Object,
      required: true,
    },
    packageIndex: {
      type: Number,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    /** 图片是否可编辑：完整编辑 或 仅图片编辑（父组件 edit-1 模式） */
    imagesEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  watch: {
    "packageData.limitType"(newVal) {
      if (newVal === 1) {
        const list = this.packageData.prizeList;
        if (list && list.length) {
          list.forEach((prize) => {
            delete prize.signLimitType;
            delete prize.signLimit;
          });
        }
      }
    },
  },
  computed: {
    packageImageHintText() {
      return "尺寸建议56*45，最大50KB，优先SVG其次png";
    },
    uploadAuthHeaders() {
      return {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      };
    },
    hasPhysicalPrize() {
      const list = this.packageData.prizeList;
      if (!list || !list.length) return false;
      return list.some((prize) => Number(prize.prizeType) === 5);
    },
  },
  methods: {
    getPrizeTypeLabel(type) {
      const map = {
        0: "站内会员",
        1: "头像挂件",
        2: "主题",
        3: "电子证书",
        4: "电子奖牌",
        5: "实物",
        6: "外链奖励",
      };
      const n = Number(type);
      return Number.isFinite(n) && map[n] != null
        ? map[n]
        : type != null
        ? String(type)
        : "–";
    },
    /** Element UI 1.x：@input 可能是字符串也可能是原生事件 */
    normalizeInputValue(val) {
      if (
        val &&
        typeof val === "object" &&
        val.target != null &&
        val.target.value !== undefined
      ) {
        return String(val.target.value);
      }
      if (val != null && val !== undefined) return String(val);
      return "";
    },
    /** 仅保留数字；至多一个小数点；小数位最多 2 位（多余小数点合并到小数部分再截断） */
    sanitizeDecimalPrice(raw) {
      let str = String(raw != null ? raw : "").replace(/[^\d.]/g, "");
      const firstDot = str.indexOf(".");
      if (firstDot === -1) return str;
      const intPart = str.slice(0, firstDot).replace(/\D/g, "");
      let decPart = str
        .slice(firstDot + 1)
        .replace(/\./g, "")
        .replace(/\D/g, "");
      decPart = decPart.slice(0, 2);
      const endsWithDotOnly = str.endsWith(".") && decPart === "";
      if (endsWithDotOnly) {
        return intPart === "" ? "" : `${intPart}.`;
      }
      if (intPart === "" && decPart !== "") return `0.${decPart}`;
      if (decPart === "") return intPart;
      return `${intPart}.${decPart}`;
    },
    /**
     * keydown 阶段拦截：只允许数字、单个小数点、小数点后最多2位。
     * 这是最可靠的防线，在字符写入 DOM 之前就阻断非法输入。
     */
    onPriceKeydown(e) {
      const key = e.key;
      // 放行：控制键 / 方向键 / Ctrl·Meta 组合
      if (
        e.ctrlKey ||
        e.metaKey ||
        [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
          "ArrowUp",
          "ArrowDown",
          "Home",
          "End",
        ].includes(key)
      )
        return;

      // 数字键
      if (/^\d$/.test(key)) {
        const cur = e.target.value;
        const dotIdx = cur.indexOf(".");
        if (dotIdx !== -1) {
          // 光标在小数点之后，且扣掉选中区域后剩余小数位已满 2 位，则阻止
          const selStart = e.target.selectionStart;
          const selEnd = e.target.selectionEnd;
          const decPart = cur.slice(dotIdx + 1);
          const selectedDecLen = Math.max(
            0,
            Math.min(selEnd, cur.length) - Math.max(selStart, dotIdx + 1)
          );
          if (selStart > dotIdx && decPart.length - selectedDecLen >= 2) {
            e.preventDefault();
          }
        }
        return;
      }

      // 小数点：已有小数点则阻止
      if (key === ".") {
        if (e.target.value.includes(".")) e.preventDefault();
        return;
      }

      // 其他字符（字母、符号等）全部阻止
      e.preventDefault();
    },
    /** 粘贴：取纯文本后经 sanitize 过滤再写入，防止粘贴带来非法字符 */
    onPricePaste(e) {
      const pasted = (e.clipboardData || window.clipboardData).getData("text");
      const cleaned = this.sanitizeDecimalPrice(pasted);
      this.packageData.price = cleaned;
      this._forcePriceDom(cleaned);
    },
    onPriceInput(val) {
      const cleaned = this.sanitizeDecimalPrice(this.normalizeInputValue(val));
      const prev = this.packageData.price;
      this.packageData.price = cleaned;
      if (prev === cleaned) this._forcePriceDom(cleaned);
    },
    onPriceBlur() {
      let s = this.sanitizeDecimalPrice(this.packageData.price || "");
      if (s.endsWith(".")) s = s.slice(0, -1);
      this.packageData.price = s;
    },
    _forcePriceDom(val) {
      this.$nextTick(() => {
        const el =
          this.$refs.priceInput &&
          this.$refs.priceInput.$el &&
          this.$refs.priceInput.$el.querySelector("input");
        if (el) el.value = val;
      });
    },
    onPriceCompositionEnd(e) {
      const cleaned = this.sanitizeDecimalPrice(
        this.normalizeInputValue(e.target.value)
      );
      this.packageData.price = cleaned;
      this._forcePriceDom(cleaned);
    },
    // -------- 套餐库存正整数限制 --------
    _cleanStock(raw) {
      return String(raw || "")
        .replace(/\D/g, "")
        .replace(/^0+(\d)/, "$1")
        .replace(/^0+$/, "");
    },
    _forceStockDom(val) {
      this.$nextTick(() => {
        const el =
          this.$refs.stockInput &&
          this.$refs.stockInput.$el &&
          this.$refs.stockInput.$el.querySelector("input");
        if (el) el.value = val;
      });
    },
    onStockKeydown(e) {
      const key = e.key;
      const allow = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Home",
        "End",
      ];
      if (allow.includes(key)) return;
      if (e.ctrlKey || e.metaKey) return;
      if (/^\d$/.test(key)) {
        const cur = e.target.value;
        if (key === "0" && cur.length === 0) {
          e.preventDefault();
          return;
        }
        return;
      }
      e.preventDefault();
    },
    onStockPaste(e) {
      const pasted = (e.clipboardData || window.clipboardData).getData("text");
      const cleaned = this._cleanStock(pasted);
      this.packageData.stock = cleaned;
      this._forceStockDom(cleaned);
    },
    onStockInput(val) {
      const cleaned = this._cleanStock(val);
      const prev = this.packageData.stock;
      this.packageData.stock = cleaned;
      if (prev === cleaned) this._forceStockDom(cleaned);
    },
    onStockCompositionEnd(e) {
      const cleaned = this._cleanStock(e.target.value);
      this.packageData.stock = cleaned;
      this._forceStockDom(cleaned);
    },
    // -------- 报名限量正整数限制 --------
    onSignLimitKeydown(e) {
      const key = e.key;
      const allow = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Home",
        "End",
      ];
      if (allow.includes(key)) return;
      if (e.ctrlKey || e.metaKey) return;
      if (/^\d$/.test(key)) {
        const cur = e.target.value;
        if (key === "0" && cur.length === 0) {
          e.preventDefault();
          return;
        }
        return;
      }
      e.preventDefault();
    },
    onSignLimitPaste(e, row) {
      const pasted = (e.clipboardData || window.clipboardData).getData("text");
      const cleaned = this._cleanStock(pasted);
      row.signLimit = cleaned;
      this.$nextTick(() => {
        const el = e.target;
        if (el) el.value = cleaned;
      });
    },
    onSignLimitInput(val, row) {
      const raw =
        val && typeof val === "object" && val.target != null
          ? String(val.target.value)
          : String(val != null ? val : "");
      const cleaned = this._cleanStock(raw);
      const prev = row.signLimit;
      row.signLimit = cleaned;
      if (prev === cleaned) {
        this.$nextTick(() => {
          const el = val && val.target ? val.target : null;
          if (el) el.value = cleaned;
        });
      }
    },
    onSignLimitCompositionEnd(e, row) {
      const cleaned = this._cleanStock(e.target.value);
      row.signLimit = cleaned;
      this.$nextTick(() => {
        if (e.target) e.target.value = cleaned;
      });
    },
    // ------------------------------------
    onRelatePrize() {
      this.$emit("relate-prize", this.packageIndex, this.packageData);
    },
    removePrize(index) {
      this.packageData.prizeList.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.section-body {
  padding: 20px 20px 10px;
  display: block;
}

/* 与 matchDetail 必填星号一致（子组件需自带样式） */
.req-star {
  color: #ff4949;
  margin-right: 4px;
}

/* 父级 detail-form 仍有 label-width，此处用手写标签列 + label-width:0；标签列用较小固定宽度，缩短标题与控件间距 */
.pkg-field-item >>> .el-form-item__label {
  width: 0 !important;
  padding: 0 !important;
  overflow: hidden;
}
.pkg-field-item >>> .el-form-item__content {
  margin-left: 0 !important;
}
.pkg-field-row {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
  width: 100%;
}
.pkg-field-row--cover-title {
  align-items: baseline;
  flex-wrap: wrap;
  margin-bottom: 10px;
  line-height: 22px;
}
.pkg-field-label {
  width: 84px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding-right: 8px;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  text-align: left;
}
.pkg-field-row--cover-title .pkg-field-label {
  line-height: 22px;
}
.pkg-field-label--wide {
  width: 144px;
}
.pkg-field-spacer {
  width: 84px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding-right: 8px;
}
.pkg-field-body {
  flex: 1;
  min-width: 0;
}

/* 套餐图片：标题与上传上下排列；上传区宽度/样式不变 */
.package-cover-block {
  margin-bottom: 18px;
  width: 100%;
  box-sizing: border-box;
}
.package-cover-upload-wrap {
  width: 100%;
  max-width: 360px;
}

.same-width-input {
  width: 520px;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
  margin-top: 4px;
}

/* 与 matchDetail.vue「赛事详情」等行的 detail-title-hint 一致（matchManage 列表无该文案样式） */
.detail-title-hint {
  font-size: 12px;
  color: #f56c6c;
  font-weight: normal;
}
.detail-title-hint--after-label {
  margin-left: 6px;
}

/* 套餐图：与赛事详情、新增动态素材区同一布局（150×180 格） */
.match-upload-block {
  width: 100%;
}
.match-dynamic-upload-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  overflow: auto;
}
.match-dynamic-upload-bezel {
  width: 360px;
  max-width: 100%;
  box-sizing: border-box;
}
.match-upload-dragger >>> .el-upload {
  width: 100%;
}
.match-upload-dragger >>> .el-upload-dragger {
  width: 100% !important;
  height: 180px !important;
  min-height: 180px !important;
  max-width: 100%;
  display: flex !important;
  flex-direction: column;
  align-items: center !important;
  justify-content: center !important;
  padding: 10px 6px !important;
  box-sizing: border-box !important;
}
.match-upload-dragger >>> .el-upload-dragger > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
}
.match-upload-dragger >>> .el-upload-dragger .el-icon-upload {
  font-size: 32px !important;
  line-height: 1 !important;
  margin: 0 0 8px !important;
  color: #c0c4cc !important;
}
.match-upload-dragger >>> .el-upload-dragger .el-dragger__text {
  font-size: 12px !important;
  color: #606266 !important;
  line-height: 1.35 !important;
  text-align: center;
  padding: 0 4px !important;
}
.match-upload-dragger >>> .el-upload-dragger .el-dragger__text em {
  color: #409eff !important;
  font-style: normal;
}
.match-upload-preview-box {
  position: relative;
  width: 100%;
  height: 180px;
  line-height: 180px;
  border: 1px solid #c0ccda;
  border-radius: 4px;
  text-align: center;
  background: #fafafa;
  overflow: hidden;
  box-sizing: border-box;
}
.match-upload-preview-box img {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.match-upload-preview-box--view {
  cursor: pointer;
}
.match-upload-close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
  z-index: 1;
}
.match-upload-loading {
  width: 100%;
  height: 180px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #409eff;
  font-size: 14px;
  box-sizing: border-box;
}
.match-upload-empty-view {
  width: 100%;
  height: 180px;
  line-height: 180px;
  text-align: center;
  color: #909399;
  font-size: 13px;
  border: 1px dashed #e4e7ed;
  border-radius: 4px;
  background: #fafafa;
  box-sizing: border-box;
}

.inline-form-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.price-unit {
  margin-left: 6px;
  color: #606266;
}

.cell-inline {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
}

.pace-radio-group {
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// PackageConfig.vue?78b91990